// @core/api/endpoints/affiliate/get_offer_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetOfferStatsResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Get offer statistics
 * Retrieves offer stats by the specified identifier.
 */
export async function GetOfferStats(
  offer_id: string,
  params?: {
    period_end?: string | number | boolean;
    period_start?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<GetOfferStatsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/offers/:offer_id/stats`;
  requestPath = requestPath.replace(':offer_id', encodeURIComponent(offer_id));
  const requestOptions = options;
  return client.get<GetOfferStatsResponse>(requestPath, { ...requestOptions, params });
}
